module.exports = __webpack_public_path__ + "static/media/BreathingTechniques.02263189.jpg";